// extracted by mini-css-extract-plugin
export default {"default":"PopBanner_default__gk34u"};